"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttachContentButton = void 0;
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const react_query_1 = require("react-query");
const Colors_1 = require("../../../../Colors");
const common_1 = require("../../../../common");
const server_1 = require("../../../../server");
const classes_1 = require("../../../base/classes");
function isVideoFile(file) {
    return file.type.startsWith('video/');
}
exports.AttachContentButton = react_1.default.memo(({ menu, isReserve = false, setUpdateCheckList, setIsUploading, isMockTest = false, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const fileRef = react_1.default.useRef(null);
    const contentsMutation = (0, react_query_1.useMutation)(server_1.postContentsList);
    const chunkMutation = (0, react_query_1.useMutation)(server_1.postChunk);
    const acceptedFileTypes = (0, react_1.useMemo)(() => menu === 'all'
        ? 'image/*,application/pdf,video/*,.zip,application/zip'
        : menu === 'document'
            ? 'application/pdf,image/*'
            : menu === 'background'
                ? 'image/*'
                : 'video/*', [menu]);
    const uploadVideoChunks = async (file, chunkSizeMB, uuid) => {
        const chunkSize = chunkSizeMB * 1024 * 1024;
        const fileSize = file.size;
        let offset = 0;
        const uploadChunk = async (chunk, index) => {
            const formData = new FormData();
            formData.append('type', 'video');
            formData.append('id', uuid);
            formData.append('file', chunk);
            try {
                const response = await chunkMutation.mutateAsync({ id: uuid, data: formData });
            }
            catch (error) {
                console.error(`Error uploading chunk ${index}:`, error);
            }
        };
        const readNextChunk = () => {
            const fileReader = new FileReader();
            const slice = file.slice(offset, offset + chunkSize);
            fileReader.onload = async (event) => {
                const chunk = event.target?.result;
                if (chunk) {
                    await uploadChunk(new Blob([chunk]), offset / chunkSize);
                    offset += chunkSize;
                    if (offset < fileSize) {
                        readNextChunk();
                    }
                    else {
                        // 빈 파일로 최종 요청
                        await uploadChunk(new Blob([]), offset / chunkSize);
                        setTimeout(() => {
                            APP.eventManager.publish('SHOW_LOADING', false);
                            APP.eventManager.publish('REFRESH_CONTENTS');
                            setIsUploading && setIsUploading(false);
                        }, 1000);
                    }
                }
            };
            fileReader.readAsArrayBuffer(slice);
        };
        readNextChunk();
    };
    const uploadDocument = async (file, uuid) => {
        const formData = new FormData();
        if (menu === 'document') {
            formData.append('type', 'document');
            formData.append('id', uuid);
        }
        formData.append('file', file);
        try {
            const response = await chunkMutation.mutateAsync({
                id: uuid,
                data: formData,
            });
            if (response)
                APP.eventManager.publish('REFRESH_CONTENTS');
        }
        catch (error) {
            console.error('Error uploading document:', error);
            alert(error);
        }
        finally {
            setTimeout(() => {
                APP.eventManager.publish('SHOW_LOADING', false);
                setIsUploading && setIsUploading(false);
            }, 1000);
        }
    };
    function getFileType(file) {
        if (file.type === 'application/pdf' || file.type.startsWith('image/'))
            return 'document';
        if (file.type.startsWith('video/'))
            return 'video';
        return 'document'; // fallback
    }
    const onChangeFile = async (e) => {
        APP.eventManager.publish('SHOW_LOADING', true);
        setIsUploading && setIsUploading(true);
        try {
            const selectedFile = e.target.files?.[0];
            if (!selectedFile) {
                throw new Error('No file selected');
            }
            let type;
            if (menu === 'all') {
                type = getFileType(selectedFile);
            }
            else if (menu === 'document') {
                type = 'document';
            }
            else if (menu === 'video') {
                type = 'video';
            }
            else if (menu === 'background') {
                type = 'background';
            }
            else {
                type = 'document';
            }
            const response = await contentsMutation.mutateAsync({
                class_id: (0, classes_1.getClassesId)(),
                type,
                name: selectedFile.name,
                size: selectedFile.size,
            });
            if (response.result.id) {
                if (isVideoFile(selectedFile)) {
                    await uploadVideoChunks(selectedFile, 10, response.result.id); // 10MB씩 나눔
                }
                else {
                    await uploadDocument(selectedFile, response.result.id); // 문서 업로드
                }
                setUpdateCheckList &&
                    // @ts-ignore
                    setUpdateCheckList(prev => prev ? [...prev, response.result.id] : [response.result.id]);
            }
            else {
                console.error('UUID error');
            }
        }
        catch (error) {
            console.error('Failed to post :', error);
            alert(error);
            APP.eventManager.publish('SHOW_LOADING', false);
            setIsUploading && setIsUploading(false);
        }
        finally {
            if (fileRef.current) {
                fileRef.current.value = '';
            }
        }
    };
    return (react_1.default.createElement(common_1.FileInput, { ref: fileRef, id: "attach_file", className: "regist_btn", onChange: onChangeFile, accept: acceptedFileTypes, isMockTest: isMockTest }, isReserve ? (react_1.default.createElement(common_1.Button, { className: "btn_default sm", text: t('conference.dataAdd') })) : (react_1.default.createElement(common_1.Button, { className: "btn_pink round", option: {
            buttonBeforeIcon: {
                show: true,
                name: 'plus',
                size: 20,
                color: Colors_1.Colors.white,
            },
        } }))));
});
